// 1. React and fabric. 
import React from 'react';
import { Outlet, useLocation }                from  'react-router-dom'                ;
// 2. Store and Types. 
// 3. Scripts. 
// 4. Components and Views. 
import MainContent                            from './ThemeComponents/MainContent'    ;

// https://codedamn.com/news/reactjs/handle-async-functions-with-ease
function PublicRouteFC()
{
	const location = useLocation();
	//console.log((new Date()).toISOString() + ' PublicRouteFC location', location);

	return (<MainContent>
		<Outlet />
	</MainContent>);
};

export default PublicRouteFC;
